export const navConfig = {
  mainNav: [
    {
      title: "I'm a 3D artist",
      href: "/seller",
    },
  ],
}
